import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../../../../../reducers/types";
import { setOpenModal } from "../../../../../../actions/actions";
import { CancelGroundModalContent } from "./component";

const mapStateToProps = (_: IStoreState) => ({});

const mapDispatchToProps = {
  setOpenModal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type CancelGroundModalContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedGroundCancelModalContent = connector(
  withRouter(CancelGroundModalContent)
);
